import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { PaymentSetupElement } from '@/Pages/PaymentSetupSuccess/components/PaymentSetupElement';
import { useColorScheme } from '@/hooks/useColorScheme';
import { ChangePaymentPlanTierSchema } from '@/types/schema';
import { stripeKey } from '@/utils/constants';

export const AddPaymentInfoModalCard = (props: {
  clientSecret: string | null;
  onPrev?: () => void;
  onNext?: () => void;
  isChangingPlan: boolean;
  targetPlanTier: ChangePaymentPlanTierSchema | null;
}) => {
  const { isDarkMode } = useColorScheme();
  const { clientSecret } = props;
  if (!clientSecret) {
    return null;
  }

  const stripe = stripeKey && stripeKey !== '' ? loadStripe(stripeKey) : null;

  return (
    <div className="min-h-[500px]">
      <Elements
        stripe={stripe}
        options={{
          clientSecret: clientSecret,
          appearance: {
            theme: isDarkMode ? 'night' : 'stripe',
          },
        }}
      >
        <PaymentSetupElement
          clientSecret={clientSecret}
          onPrev={props.onPrev}
          onNext={props.onNext}
          targetPlanTier={props.targetPlanTier}
          loading={props.isChangingPlan}
        />
      </Elements>
    </div>
  );
};
